(function($){
    $(function(){
        var $openHubChat = $('.zn-open-hub-chat'),
            $doc = $(document);

        $openHubChat.click(function(e){
            e.preventDefault();
            if (typeof window.HubSpotConversations.widget.open === 'function'){
                window.HubSpotConversations.widget.open();

                $doc.one('keydown', function(e){
                    if(e.which === 27 && typeof window.HubSpotConversations.widget.close === 'function'){ //add escape key to close chat 
                        window.HubSpotConversations.widget.close(); 
                    }
                });
            }
        });

    });
})($JQ);